import { css } from 'src/styles/theme';

export const StylesDS = css``;
